import { render, staticRenderFns } from "./StickerSuccessPage.vue?vue&type=template&id=006173ba&scoped=true&"
import script from "./StickerSuccessPage.vue?vue&type=script&lang=ts&"
export * from "./StickerSuccessPage.vue?vue&type=script&lang=ts&"
import style0 from "./StickerSuccessPage.vue?vue&type=style&index=0&id=006173ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006173ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VContainer,VProgressCircular})
